// extracted by mini-css-extract-plugin
module.exports = {"spacer":"vertical-spacer_spacer__U0eWo"};